import React, { Component, Suspense } from "react";
import { Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Home, Stores, Stamp, NotFound } from '../pages';

class App extends Component {

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>First stamp</title>
        </Helmet>
        <Switch>
          <Route exact path="/" component={Home}/>
          <Route exact path="/@:id" component={Stores}/>
          <Route path="/@:id/:store/" component={Stamp}/>
          <Route component={NotFound} />
        </Switch>
      </React.Fragment>
    );
  }
}

const Loader = () => (
  <div className="App">
    <div>loading...</div>
  </div>
);

const AppContainer = () => (
  <Suspense fallback={<Loader />}>
    <App />
  </Suspense>
);

export default AppContainer;